<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('payment-listings')" :icon="'grid'" />
            </div>
            <!-- <div 
                class="col-sm-12 col-md-6 breadcrumb-side-button"
                v-if="this.$can('store_payment-listings')"
            >
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal"
                        @click="openAddEditModal">
                        {{ this.$t('download') }}
                    </button>
                </div>
            </div> -->
        </div>

        <app-table :id="tableId" :options="options" @action="getListAction" />

        <payment-listing-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="payment-listing-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import AppFunction from '../../../../core/helpers/app/AppFunction';
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { status } from '../../../Mixins/FilterMixin';

export default {
    extends: CoreLibrary,
    mixins: [status],
    name: "AppPaymentListings",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'payment-listings-table',
            rowData: {},
            options: {
                name: 'AppPaymentListings',
                url: actions.PAYMENT_LISTING,
                showHeader: true,
                enableHighlights: true,
                enableRowSelect: false,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t('Photo'),
                        type: 'media-object',
                        key: 'employee',
                        mediaTitleKey: '',
                        mediaSubtitleKey: '',
                        default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
                        modifier: (value, row) => {
                            return value.photo; // imag url
                        },
                        isVisible: true
                    },
                    {
                        title: this.$t('matricule'),
                        type: 'custom-html',
                        key: 'employee',
                        modifier: (value, row) => {
                            return `<span>${value.matricule}</span>`;
                        }
                    },
                    {
                        title: this.$t('employee'),
                        type: 'custom-html',
                        key: 'employee',
                        modifier: (value, row) => {
                            return `<span>${value.last_name} ${value.middle_name} ${value.first_name}</span>`;
                        }
                    },
                    {
                        title: this.$t('bank_account_number'),
                        type: 'custom-html',
                        key: 'employee',
                        modifier: (value, row) => {
                            if (value.bank_account_number === null) {
                                return `<span>-</span>`;
                                
                            }
                            return `<span>${value.bank_account_number}</span>`;
                        }
                    },
                    {
                        title: this.$t('payroll_period'),
                        type: 'custom-html',
                        key: 'period',
                        modifier: (value, row) => {
                            return `<span>${value.name}</span>`;
                        }
                    },
                    {
                        title: this.$t('currency'),
                        type: 'text',
                        key: 'currency',
                    },
                    {
                        title: this.$t('base_salary'),
                        type: 'text',
                        key: 'base_salary',
                    },
                    {
                        title: this.$t('ipr_due_usd'),
                        type: 'text',
                        key: 'ipr_due_usd',
                    },
                    {
                        title: this.$t('cnss'),
                        type: 'text',
                        key: 'cnss_employee',
                    },
                    {
                        title: this.$t('net_salary'),
                        type: 'text',
                        key: 'net_salary',
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
						title: this.$t('download'),
                        icon: 'printer',
						type: 'download',
						modifier: () => this.$can("payslip_download"),
					},
                    {
                        title: this.$t('reset'),
                        icon: 'rotate-ccw',
                        type: 'reset',
                        modifier: () => this.$can('reset_payrolls'),
                    }
                ],
                filters: [
                    {
                        "title": this.$t('created_at'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                    {
                        title: this.$t("periods"),
                        type: "multi-select-filter",
                        type: "multi-select-filter",
                        key: "periods",
                        option: [],
                        permission: true
                    },
                ],
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal 
         */
        closeAddEditModal() {
            $("#payment-listing-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.openDeleteModal();
            }  else if (actionObj.title == this.$t('download')) {
				window.open(AppFunction.getAppUrl(`payslip-download/${rowData.id}`))
			}
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.PAYMENT_LISTING}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#payment-listing-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>
